import SEOHead from "@/components/General/SEOHead";
import Services from "@/modules/Services/Services";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const ServicesPage = () => {
  return (
    <>
      <SEOHead />
      <Services />
    </>
  );
};

export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default ServicesPage;
